import { FileText, Trash2, Plus, Flag } from "lucide-react";

export default function HistorySidebar({ notes, activeId, onSelect, onNew, onDelete }) {
  return (
    <aside className="w-full" data-testid="history-sidebar">
      <button
        data-testid="new-note-btn"
        onClick={onNew}
        className="w-full h-11 mb-5 rounded-full bg-[#4A6B53] hover:bg-[#3D5A45] text-white text-sm font-medium flex items-center justify-center gap-2 shadow-[0_6px_14px_rgba(74,107,83,0.25)] transition-colors"
      >
        <Plus className="w-4 h-4" strokeWidth={2} /> New Note
      </button>

      <h4 className="text-[10px] font-bold text-[#7A8C82] uppercase tracking-[0.2em] mb-3 px-1">
        Recent Notes
      </h4>

      {notes.length === 0 && (
        <p className="text-sm text-[#7A8C82] px-1 leading-relaxed">
          Your saved notes will show up here.
        </p>
      )}

      <div className="space-y-2">
        {notes.map((n) => {
          const s = n.structured || {};
          const active = n.id === activeId;
          return (
            <button
              key={n.id}
              data-testid={`history-item-${n.id}`}
              onClick={() => onSelect(n)}
              className={`group w-full text-left p-3 rounded-xl border transition-colors ${
                active
                  ? "bg-[#DCE5DF] border-[#4A6B53]"
                  : "bg-white border-[#E2DFD8] hover:bg-[#F4F3EF]"
              }`}
            >
              <div className="flex items-start gap-2.5">
                <div className="mt-0.5 w-7 h-7 shrink-0 rounded-lg bg-[#EAE8E3] flex items-center justify-center">
                  <FileText className="w-3.5 h-3.5 text-[#4A6B53]" strokeWidth={1.5} />
                </div>
                <div className="min-w-0 flex-1">
                  <div className="flex items-center justify-between gap-2">
                    <p className="text-sm font-semibold text-[#121814] truncate">
                      {s.member_name || "Unnamed member"}
                    </p>
                    <span
                      className={`text-[9px] font-bold uppercase tracking-wide px-1.5 py-0.5 rounded ${
                        n.status === "finalized"
                          ? "bg-[#4A6B53] text-white"
                          : "bg-[#EAE8E3] text-[#7A8C82]"
                      }`}
                    >
                      {n.status === "finalized" ? "Final" : "Draft"}
                    </span>
                  </div>
                  <p className="text-xs text-[#7A8C82] truncate">
                    {s.date_of_service || new Date(n.updated_at).toLocaleDateString()}
                  </p>
                  {n.goal_flagged && (
                    <span data-testid={`history-flag-${n.id}`} className="mt-1 inline-flex items-center gap-1 text-[9px] font-bold uppercase text-[#C26D5C]">
                      <Flag className="w-3 h-3" strokeWidth={2} /> Goal check
                    </span>
                  )}
                </div>
                <span
                  role="button"
                  data-testid={`delete-note-${n.id}`}
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(n.id);
                  }}
                  className="opacity-0 group-hover:opacity-100 text-[#7A8C82] hover:text-[#C26D5C] transition-opacity"
                >
                  <Trash2 className="w-3.5 h-3.5" strokeWidth={1.5} />
                </span>
              </div>
            </button>
          );
        })}
      </div>
    </aside>
  );
}
